bcp47
	ru-RU
name
	Русский
name.short
	ru

page.title
	cryptopup

chains.label
	Сеть
address.label
	Адрес кошелька назначения
count.label
	Сумма (USDT)

button.copy
	Скопировать ссылку
button.copied
	✔️ Скопировано в буффер обмена
